export const TABLET_VIEW = 1024
export const MOBILE_VIEW = 520
